// extracted by css-extract-rspack-plugin
export default {"list":"list-erySbu","title":"title-XByaSI","scrollable":"scrollable-JxkW81"};